export const trustpilot = {
    settings: {
        carouselContainer: null,
        touchStartX: 0,
        touchEndX: 0,
        isDragging: false,
        dragStartX: 0,
        dragEndX: 0,
        nextButton: null,
        prevButton: null
    },

    init() {
        const container = document.querySelector(".brtpmj-carousel-container");
        if (!container) return;

        this.settings.carouselContainer = container;
        this.settings.nextButton = container.querySelector(".brtpmj-slider-next");
        this.settings.prevButton = container.querySelector(".brtpmj-slider-prev");

        this.setAccessibilityAttributes();
        this.setEventListeners();
    },

    setAccessibilityAttributes() {
        const { carouselContainer, nextButton, prevButton } = this.settings;

        carouselContainer.setAttribute("role", "region");
        carouselContainer.setAttribute("aria-label", "User reviews carousel");

        prevButton.setAttribute("aria-label", "Previous review");
        prevButton.setAttribute("tabindex", "0");

        nextButton.setAttribute("aria-label", "Next review");
        nextButton.setAttribute("tabindex", "0");
    },

    setEventListeners() {
        const {
            carouselContainer,
            nextButton,
            prevButton
        } = this.settings;

        carouselContainer.addEventListener("touchstart", event => {
            this.settings.touchStartX = event.changedTouches[0].screenX;
        });

        carouselContainer.addEventListener("touchend", event => {
            this.settings.touchEndX = event.changedTouches[0].screenX;
            this.handleSwipeGesture();
        });

        carouselContainer.addEventListener("mousedown", event => {
            this.settings.isDragging = true;
            this.settings.dragStartX = event.screenX;
            carouselContainer.classList.add("dragging");
        });

        carouselContainer.addEventListener("mousemove", event => {
            if (this.settings.isDragging) {
                this.settings.dragEndX = event.screenX;
            }
        });

        carouselContainer.addEventListener("mouseup", () => {
            if (!this.settings.isDragging) return;
            this.settings.isDragging = false;
            carouselContainer.classList.remove("dragging");
            this.handleDragGesture();
        });

        carouselContainer.addEventListener("mouseleave", () => {
            this.settings.isDragging = false;
            carouselContainer.classList.remove("dragging");
        });

        document.addEventListener("keydown", event => {
            const activeElement = document.activeElement;
            const isCarouselFocused = carouselContainer.contains(activeElement);
            const isButtonFocused = activeElement === nextButton || activeElement === prevButton;

            if (isCarouselFocused || isButtonFocused) {
                if (event.key === "ArrowRight") nextButton.click();
                if (event.key === "ArrowLeft") prevButton.click();
            }
        });
    },

    handleSwipeGesture() {
        const distance = this.settings.touchEndX - this.settings.touchStartX;
        if (distance < -50) this.settings.nextButton.click();
        if (distance > 50) this.settings.prevButton.click();
    },

    handleDragGesture() {
        const distance = this.settings.dragEndX - this.settings.dragStartX;
        if (distance < -50) this.settings.nextButton.click();
        if (distance > 50) this.settings.prevButton.click();
    }
};
